import { useEffect, useState } from "react"
import { logoIcon } from "../../icons"
import "./login.page.css"
import { login } from "../../firebase"
import { auth } from "../../firebase"
import { useAuthState } from "react-firebase-hooks/auth"
import { useNavigate } from "react-router-dom"
import { gsap } from "gsap"

const LoginPage = () => {
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [error, setError] = useState()
  const [user, loading] = useAuthState(auth)
  const navigate = useNavigate()

  const handleLogin = async () => {
    // Reset error
    setError(false)

    try {
      await login(email, password)
    } catch {
      setError(true)
    }
  }

  useEffect(() => {
    gsap.set(".cb-login svg", {
      yPercent: -100,
      opacity: 0,
      scale: 0.9,
    })

    gsap.set(".cb-login h4", {
      yPercent: 54,
      opacity: 0,
    })

    gsap.set(".cb-login input", {
      yPercent: 50,
      opacity: 0,
    })

    gsap.set(".cb-login button", {
      yPercent: -50,
    })

    if (loading) {
      return
    }

    // Redirect to dashboard if we have a user
    if (user) {
      return navigate("/dashboard", { replace: true })
    }

    // Animate
    gsap.fromTo(
      ".cb-login svg",
      {
        yPercent: -100,
        opacity: 0,
        scale: 0.9,
      },
      {
        yPercent: 0,
        opacity: 1,
        scale: 1,
        duration: 0.5,
        ease: "power3.inOut",
      }
    )

    gsap.fromTo(
      ".cb-login h4",
      {
        yPercent: 54,
        opacity: 0,
      },
      {
        yPercent: 0,
        opacity: 1,
        duration: 0.6,
        delay: 0.2,
        ease: "power3.inOut",
      }
    )

    gsap.fromTo(
      ".cb-login input",
      {
        yPercent: 50,
        opacity: 0,
      },
      {
        yPercent: 0,
        opacity: 1,
        duration: 0.6,
        delay: 0.2,
        ease: "power3.inOut",
      }
    )

    gsap.fromTo(
      ".cb-login button",
      {
        yPercent: -50,
      },
      {
        yPercent: 0,
        duration: 0.5,
        delay: 0.3,
        ease: "power3.inOut",
      }
    )
  }, [user, loading, navigate])

  return (
    <div className="cb-page flex-centered">
      <div className="cb-login">
        <div className="cb-login-left">
          {logoIcon}
          <img src="/cell.png" alt="Cellsbin" />
        </div>
        <div className="cb-login-right">
          <h1>Sign in to Cellsbin</h1>
          <h5>
            Please contact your administrator if you don't have an account yet.
          </h5>
          <h4>Email</h4>
          <input
            type="email"
            placeholder="Email..."
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <h4>
            Password <span>Forget?</span>
          </h4>
          <input
            type="password"
            placeholder="Password..."
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <button
            className="cb-primary-btn"
            disabled={!email || !password}
            onClick={handleLogin}
          >
            Sign In
          </button>
          <div className="remember-me">
            <span /> Remember me
          </div>
          {error && (
            <div className="cb-error">
              Uh oh. Looks like your email and/or password was incorrect. Please
              try again
            </div>
          )}
          <div className="legal">
            <span>Privacy</span> and <span>Terms</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LoginPage
